/* eslint-disable no-shadow */
import OrderModel from '@/common/models/order-model';

export const state = {
    orders: [],
};

export const mutations = {
    setState(state, {property, payload}) {
        state[property] = payload;
    },
};

export const getters = {
    activeOrders(state) {
        return state.orders.filter(order => order.isActive);
    },
    activeSubscriptionOrders(state) {
        return state.orders.filter(order => order.isActive
            && order.orderType !== OrderModel.Types.oneTime);
    },
    pastOneTimeOrders(state) {
        return state.orders.filter(order => order.isActive
            && order.orderType === OrderModel.Types.oneTime);
    },
    pendingOrders(state) {
        return state.orders.filter(order => order.isPending);
    },
    pastOrders(state) {
        return state.orders.filter(order => order.isPast);
    },
};

export const actions = ({api}) => ({
    async fetchCustomerOrders({commit}, payload) {
        const {params} = payload;
        const {items} = await api(({subscriptions}) => subscriptions.allowedOnly.getAll({
            filter: `customerId:${params}`,
        }));
        commit('setState', {
            property: 'orders',
            payload: items.map(order => new OrderModel(order.fields)),
        });
    },
});
